import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogoutClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmLogout = () => {
    setIsLoggingOut(true);
    setShowConfirmModal(false);

    // Show the logout animation for 2 seconds before actually logging out
    setTimeout(() => {
      logout();
      navigate('/login');
    }, 2000);
  };

  const handleCancelLogout = () => {
    setShowConfirmModal(false);
  };

  // Confirmation Modal Component
  const ConfirmLogoutModal = () => {
    if (!showConfirmModal) return null;

    return (
      <div className="fixed inset-0 z-9999 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            className="fixed inset-0 bg-gray-500/75 transition-opacity"
            onClick={handleCancelLogout}
          ></div>

          <div className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg
                  className="h-6 w-6 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                  />
                </svg>
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3 className="text-base font-semibold leading-6 text-gray-900">Confirm Logout</h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Are you sure you want to log out? You'll need to sign in again to access your
                    account.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                className="inline-flex w-full justify-center rounded-lg bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 sm:ml-3 sm:w-auto"
                onClick={handleConfirmLogout}
              >
                Yes, Logout
              </button>
              <button
                type="button"
                className="mt-3 inline-flex w-full justify-center rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                onClick={handleCancelLogout}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Logout Animation Modal Component
  const LogoutAnimationModal = () => {
    if (!isLoggingOut) return null;

    return (
      <div className="fixed inset-0 z-9999 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="fixed inset-0 bg-black/70 transition-opacity"></div>

          <div className="relative transform overflow-hidden rounded-lg bg-white text-center shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-8">
            <div className="flex flex-col items-center">
              <div className="w-24 h-24 mb-6 animate-pulse">
                <img
                  src="/badges/kitty_sleep.png"
                  alt="Sleeping kitty"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Logging you out...</h3>
              <p className="text-sm text-gray-500 mb-4">Sweet dreams! 😴</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <button
        className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        onClick={handleLogoutClick}
      >
        Logout
      </button>

      <ConfirmLogoutModal />
      <LogoutAnimationModal />
    </>
  );
};

export default LogoutButton;
